import { object, string } from 'yup';

import { testEmail } from '../../../../validationUtils';

let personSchema = object({
  name: string().required('Attendee name is required'),
  email: testEmail(true),
});

export const validateForm = async (personData: {}) => {
  const errors: Record<string, string> = {};

  await personSchema
    .validate(personData, { abortEarly: false })
    .catch((err) => {
      err.inner.forEach((error: any) => {
        errors[error.path] = error.errors[0];
      });
    });

  return errors;
};
